import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faXmark } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";
import "./NotesInForm.scss";

interface IProps {
    icon?: IconProp;
    text: string;
}

const NotesInForm = (props: IProps) => {
    return (
        <div className="notesInForm">
            {props.icon && <FontAwesomeIcon icon={faInfoCircle} />}
            <p className="textInForm">{props.text}</p>
        </div>
    );
};

export default NotesInForm;
